<template>
  <div class="content">
    <div>
      <textarea
        placeholder="输入你的反馈意见或投诉内容，我们将尽快为您处理"
        name=""
        id=""
        cols="30"
        rows="10"
        v-model="text"
      ></textarea>
    </div>
    <div class="buton" @click="complaint">提交</div>
    <div id="appLoading" v-if="pageLoading">
      <div class="loading"></div>
    </div>
  </div>
</template>

<script>
/**
@description: 反馈
@createTime:2021-09-23
@create:wq
*/
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      text: "",
      pageLoading:false,
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {},
  methods: {
    complaint() {
      if (!this.text) {
        return this.Toast("内容不能为空");
      }
      this.pageLoading = true;
      this.api.complaint({ contents: this.text }).then(() => {
        this.text = ''
        this.pageLoading = false
        this.Toast.success("提交成功");
        setTimeout(() => {
          this.$router.go(-1);
        }, 2000);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  margin: 0 0.24rem;
  padding: 20px 0;
}
textarea {
  width: 100% !important;
  border: none;
  outline: none;
  resize: none;
}
</style>
